import {Controller} from "stimulus"
import { FetchRequest } from "@rails/request.js"

export default class extends Controller {
    static targets = ["dropdownText", "dropdown"]

    connect() {
        console.log("input-field controller connected to element:", this.element);
        const selectElement = document.querySelector('#input_field_id');
        console.log("Looking for select element with ID 'input_field_id':", selectElement);
        if (selectElement) {
            console.log("Select options:", Array.from(selectElement.options).map(opt => ({value: opt.value, text: opt.text})));
        }
    }

    toggleChoices(e) {
        const choicesArea = document.querySelector(".choices-area")
        const fieldsetArea = document.querySelector(".fieldset-config-area")
        const isChosable = ['select', 'radio', 'multi_select'].includes(e.target.value)
        const isFieldset = e.target.value === 'fieldset'

        if (choicesArea) {
            if (isChosable) {
                choicesArea.classList.remove("hidden")
            } else {
                choicesArea.classList.add("hidden")
            }
        }

        if (fieldsetArea) {
            if (isFieldset) {
                fieldsetArea.classList.remove("hidden")
            } else {
                fieldsetArea.classList.add("hidden")
            }
        }
    }

    addToObjekt(e) {
        console.log("adding input to object", e)
        console.log("Select element:", e.target)
        console.log("Select element value:", e.target.value)
        console.log("Select element selectedIndex:", e.target.selectedIndex)
        console.log("Select element options:", e.target.options)

        // Get the input ID directly from the target (select element)
        const inputId = e.target.value
        const objektId = document.querySelector(".objekt-id").value
        const objektKlass = document.querySelector(".objekt-klass").value

        console.log("Input ID:", inputId, "Objekt ID:", objektId, "Objekt Klass:", objektKlass)

        // Check if it's the prompt option (which has an empty value or specific text)
        if (!inputId || inputId === '' || inputId === 'Select an input field...' || e.target.selectedIndex === 0) {
            console.error("No input field selected - this is the prompt option")
            return
        }

        this.performAssignment(inputId, objektId, objektKlass)
    }

    performAssignment(inputId, objektId, objektKlass) {

        // Show loading state
        const dropdownText = this.dropdownTextTarget
        const originalText = dropdownText.textContent
        dropdownText.textContent = "Adding..."

        // Close the dropdown
        if (this.hasDropdownTarget) {
            this.dropdownTarget.setAttribute("aria-expanded", "false")
        }

        const formData = new FormData()
        formData.append("input_id", inputId)
        formData.append("objekt_id", objektId)
        formData.append("objekt_klass", objektKlass)

        const request = new FetchRequest("post", "/input_fields/assign_to_object", {
            body: formData,
            headers: {
                "Accept": "text/vnd.turbo-stream.html"
            }
        })

        request.perform()
            .then(response => {
                if (response.ok) {
                    // Reset dropdown text
                    dropdownText.textContent = "Select an input field..."
                    // Reset the select value
                    const selectElement = document.querySelector("#input_field_id")
                    if (selectElement) {
                        selectElement.value = ""
                    }
                } else {
                    // Handle error
                    dropdownText.textContent = "Error adding field"
                    setTimeout(() => {
                        dropdownText.textContent = originalText
                    }, 2000)
                }
            })
            .catch(error => {
                console.error("Error:", error)
                dropdownText.textContent = "Error adding field"
                setTimeout(() => {
                    dropdownText.textContent = originalText
                }, 2000)
            })
    }
}
